import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../layout/theme-next';
import { NextTheme } from '../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    lineHeight: 1.25,
    color: Colors.textBlack,
  },
  icon: {
    marginRight: theme.spacing(1),
    color: Colors.primaryLight,
  },
}));
